export const VERSION_TESTNET = '4.3.0-beta.3'
export const VERSION_MAINNET = '4.2.2'
export const AGAVE_PATCH = ''
export const AGAVE_TESTNET_PATCH = ''
export const VERSION_JITO_TESTNET = '4.3.0-beta.3'
export const VERSION_JITO_MAINNET = '4.2.2'
export const JITO_PATCH = ''
export const JITO_TESTNET_PATCH = ''
export const VERSION_BAM_TESTNET = '4.3.0-beta.3'
export const VERSION_BAM_MAINNET = '4.2.2'
export const BAM_PATCH = ''
export const BAM_TESTNET_PATCH = ''
export const VERSION_JITO_RPC = '4.2.2'
export const VERSION_SOLANA_RPC = '4.2.2'
export const DELINQUENT_STAKE_TESTNET = 10
export const DELINQUENT_STAKE_MAINNET = 5
export const COMMISSION = 5
export const VERSION_NODE = '24.16.0'
export const VERSION_FIREDANCER_TESTNET = '0.1202.40302'
export const VERSION_FIREDANCER = '0.1106.40201'
export const FIREDANCER_PATCH = ''
export const VERSION_DZ_TESTNET = '0.36.0-1'
export const VERSION_DZ_MAINNET = '0.35.0-1'
export const MEV_COMMISSION = 0
